import {Component} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute} from "@angular/router";
import {DashboardService} from "../../service/dashboard.service";
import {
  ContractFrequencyEnum,
  ContractsRequestDto,
  ContractsRuntimeDto, ContractsRuntimeInsuranceDto,
  ContractStatusEnum
} from "../../../cross/contracts/types/contracts.types";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {ProfileDto} from "../../../cross/user/types/user.types";
import {MessageHelper} from '../../../core/helper/message-helper';
import {AppMessageService} from "../../../core/service/app-message.service";


@Component({
  selector: 'ds-home-page',
  templateUrl: './home.page.html',
})
export class HomePage extends CorePage {

  override defaultLabel: string = "Home";
  override busy: boolean = false;
  contractsRuntime: ContractsRuntimeDto | undefined;

  userProfileDto?: ProfileDto;
  userProfilePhoto?: string | null;
  contractFrequencyOptions: any[] = [
    {label: 'Jährlich', value: ContractFrequencyEnum.annually},
    {label: 'Monatlich', value: ContractFrequencyEnum.monthly}
  ];
  contractFrequency: ContractFrequencyEnum = ContractFrequencyEnum.monthly;
  showContractFrequency: boolean = true;

  showUnManagedContracts:  ContractsRuntimeInsuranceDto[] | undefined;

  constructor(
    protected override route: ActivatedRoute,
    protected dashboardService: DashboardService,
    protected messageService: AppMessageService,
    protected userApiService: UserApiService
  ) {
    super(route);

  }

  override ngOnInit() {
    super.ngOnInit();


    // contracts data changed
    this.dashboardService.dashboardSubject.subscribe(value => {

      this.contractsRuntime = value;

      this.showUnManagedContracts = this.contractsRuntime?.contracts?.filter(item => item?.notFullyManaged);
      this.busy = false;
      this.initialized = true;
    });

    // load initial contracts
    let contractsRequestDto = this.createInitialRequest();
    contractsRequestDto.requestedFrequency = this.contractFrequency;
    this.dashboardService.changeRequest(contractsRequestDto);

    // load user profile
    this.getUserProfile();

  }

  initAgain() {
    this.dashboardService.changeRequest(this.createInitialRequest());
  }

  protected createInitialRequest(): ContractsRequestDto {

    return {
      includeContractPartnerData: true,
      includeContractDetails: false,
      includeInsurableObjects: true,
      filterStatusIds: [ContractStatusEnum.active, ContractStatusEnum.pending]
    };

  }

  protected getUserProfile() {
    this.userApiService.getProfile().subscribe((res: ProfileDto) => {
      this.userProfileDto = res;
      if (res.exUserPhotoDto) {
        this.userProfilePhoto = `data:${res.exUserPhotoDto.mimeType};base64,${res.exUserPhotoDto.dataBase64}`;
      }
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  handleFrequencyChangeFilter(frequency: ContractFrequencyEnum) {
    this.busy = true;
    let contractsRequestDto = this.createInitialRequest();
    contractsRequestDto.requestedFrequency = this.contractFrequency;

    this.dashboardService.changeRequest(contractsRequestDto);

  }

  handleShowGroup(value: boolean) {
    this.showContractFrequency = value;
  }
}
